const en_whs_itemstock = {
    "": "item stock",
    detail: "item stock detail",
    req_in: "in request",
    req_out: "out request",

    label: {
        available: "available",
        low: "low stock",
        out_of_stock: "out of stock",
        stock_detail: "view stock detail",
        stock_status: "stock status",
    },
}

export default en_whs_itemstock;